import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FireflyEffect from '../components/FireflyEffect';
import Captcha from '../components/Captcha';
import '../styles/ContactPage.css';
import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  const baseUrl =
  process.env.NODE_ENV === "production"
    ? "https://grauconejo13-portfolio-backend.netlify.app"
    : "http://localhost:8888";

  const CONTACT_ENDPOINT = `${baseUrl}/.netlify/functions/sendContactEmail`;
  const [captchaToken, setCaptchaToken] = useState(null);
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {

          // DEBUG: Check if your environment variables are loading
      console.log("📛 RECAPTCHA_SITE_KEY:", process.env.REACT_APP_RECAPTCHA_SITE_KEY);
      console.log("📬 CONTACT_ENDPOINT:", process.env.REACT_APP_CONTACT_ENDPOINT);


    const params = new URLSearchParams(location.search);
    if (params.get('success') === 'true') {
      setShowModal(true);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setErrorMessage('⚠️ Please verify that you are not a robot.');
      return;
    }

    const form = e.target;
    const name = form.name.value;
    const email = form.email.value;
    const message = form.message.value;

    try {
      const res = await fetch(process.env.REACT_APP_CONTACT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message, token: captchaToken }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        const devError =
          data.message ||
          `Error ${res.status}: ${res.statusText}` ||
          "Unknown backend error";
        console.error("❌ Backend error:", devError);
        setErrorMessage(devError);
      } else {
        setErrorMessage('');
        setShowModal(true);
        form.reset();
        setCaptchaToken(null); // clear after submit
      }
    } catch (err) {
      console.error("❌ Frontend fetch error:", err);
      setErrorMessage(`Frontend Error: ${err.message}`);
    }

  };

  return (
    <div className="contact-wrapper">
      <FireflyEffect />

      <Helmet>
        {/* ✅ Load reCAPTCHA script in HEAD */}
        <script
          src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`}
          async
          defer
        ></script>

        <title>Contact | Vanessa Victorino</title>
        <meta name="description" content="Let's connect — open to collaborations, freelance work, and curious conversations. Reach out directly through the form or socials." />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact Vanessa Victorino" />
        <meta property="og:description" content="Looking to build something together or ask a question? Drop me a message — I’d love to hear from you." />
        <meta property="og:url" content={`${baseUrl}/contact`} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={`${baseUrl}/preview-contact.jpg`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Reach Out to Vanessa Victorino" />
        <meta name="twitter:description" content="Open for collabs, ideas, feedback, and networking — feel free to say hi." />
        <meta name="twitter:image" content={`${baseUrl}/twitter-contact.jpg`} />
      </Helmet>

      <div className="contact-container">
        <h1>Contact Me</h1>

        {errorMessage && (
          <div className="captcha-error-message has-text-danger has-text-centered mb-4">
            {errorMessage}
          </div>
        )}

        <form onSubmit={handleSubmit} id="contact-form" className="form-horizontal" role="form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input id="name" name="name" type="text" maxLength="30" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" name="email" type="email" maxLength="30" required />
            </div>
          </div>

          <div className="form-group full-width">
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" rows="6" maxLength="1000" required />
          </div>

          <div className="form-group form-submit-row" style={{ textAlign: 'center' }}>
            <Captcha onVerify={setCaptchaToken} />
            <button type="submit" className="btn">Send Message</button>
          </div>
        </form>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Thanks for reaching out!</h2>
            <p>I'll be in touch soon.</p>
            <button className="close-btn" onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactPage;
